import React, { useContext } from 'react';
import { Context } from './StockManagerContext.jsx';

// Bootstrap alert for discrete display
const CurrentUserInfo = () => {
  const { currentUser } = useContext(Context) || {};
  if (!currentUser) return null;
  const { email, userRole, territory, salesPerson, userSwitched } = currentUser;
  return email ? (
    <div style={{
      minWidth: 200,
      display: 'block',
      position: 'absolute',
      top: -27,
      right: 0,
      fontWeight: 400,
      color: '#aaa',
      fontSize: '0.8rem',
      background: userSwitched ? 'lightyellow' : 'transparent'
    }}>
      {email}
      {(userRole || territory || salesPerson) && (
        <span>
          &nbsp;({[userRole, territory, salesPerson].filter(Boolean).join(' / ')})
        </span>
      )}
    </div>
  ) : null;
};

export default CurrentUserInfo;
